<template>
  <div>
    <nonet/>
    <draggableButton
      @touchstart="onTouchStart"
      @touchend="onTouchEnd"
      @mousedown="onMouseDown"
      @mouseup="onMouseUp"
      @click="handleClick"
    >
      <div @click="gotoLottery">
        <img src="@/assets/img/detail/lottery_icons.png"/>
      </div>
    </draggableButton>
    <div class="booth">

      <div class="swiper-wrapper" v-if="wifi == 1">
        <van-swipe :autoplay="-1" lazy-render indicator-color="#E7BB8F" class="custom-swipe" height="80vh">
          <van-swipe-item v-if="videoFiles && videoFiles.length > 0">
            <div class="media-wrapper">
              <video
                :src="videoFiles[0]"
                type="video/mp4"
                :muted="false"
                controls
                controlslist="nodownload"
                autoplay="autoplay"
              ></video>
            </div>
          </van-swipe-item>
          <van-swipe-item v-for="image in storeArr['backgroundImgs']" :key="image">
            <div class="media-wrapper">
              <img :src="image" class="booth-bannerImg"/>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="swiper-wrapper" v-if="wifi == 2">
        <van-swipe :autoplay="6000" lazy-render indicator-color="#E7BB8F" height="calc(960px / 100)">
          <van-swipe-item v-for="image in storeArr['backgroundImgs']" :key="image">
            <img :src="image" class="booth-bannerImg"/>
          </van-swipe-item>
        </van-swipe>
      </div>
      <!-- <div><img src="storeArr.backgroundImgs" class="booth-bannerImg" /></div> -->
      <div class="content" v-touch:swipeup="topSlide">
        <div class="info">
          <div class="title">
            <div class="left">
              <div class="booth-title">
                <div class="left">
                  <img src="@/assets/img/my/user-logo.png" class="booth-bannerImg" v-if="storeArr.logo == null"/>
                  <img :src="storeArr.logo" alt="" v-else/>
                  <span>
                    <slot name="title">{{ storeArr.storeName }}</slot>
                  </span>
                </div>
                <ul>
                  <li>信誉:</li>
                  <li>
                    <slot name="reputation">{{ storeArr.honestyName }}</slot>
                  </li>
                </ul>
              </div>
            </div>
            <div class="link" style="margin-left: auto">
              <router-link tag="div" to="/homeClone">随便逛逛</router-link>
            </div>
          </div>
          <Notice :noticeList="noticeList" :isIcon="typet"></Notice>
        </div>
        <div class="link-slide">
          <span>上滑进入展品列表</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import api from '../../utils/api'
import {aGet, aPost} from '../../utils/request'
import indexedDB from '../../indexedDB'
import {get} from 'http'
import Nonet from '../nonet/nonet.vue'
import nfc from '../../utils/nfc.js'

export default {
  name: 'home',
  components: {
    Nonet,
    Notice: () => import('../../components/notice/Notice'),
    BoothTitle: () => import('../../components/boothTitle/BoothTitle'),
    draggableButton: () => import('../../components/draggable-button/index.vue')
  },
  data() {
    return {
      btnIsClick: false,
      isDragging: false,
      storeArr: {},
      videoFiles: [],
      typet: true,
      permissionsList: [],
      powerStatus: undefined,

      wifi: 1,
      mydbname: 'tts',
      myversion: 1,
      msg: '8888',

      uid: parseInt(localStorage.getItem('id')),
      storeId: parseInt(localStorage.getItem('storeId'))
    }
  },
  computed: {
    //公告
    noticeList({$data}) {
      let arr = [{content: $data.storeArr.introduce}]
      return arr
    }
  },
  created() {
    console.log('/pages/home/home')
    //nfc.listenNFCStatus()
    //nfc.readData()
    this.setStoreId(JSON.parse(localStorage.getItem('storeId')))
    console.log(this.$store.state)
    if (navigator.onLine) {
      this.wifi = 1
      let reception = this.$route.query
      this.getAllStorePermissionsList()

      if (window.plus) {
        this.getLocationOnReady()
      } else {
        document.addEventListener('plusready', this.getLocationOnReady, false)
      }
      if (Object.entries(reception).length !== 0) {
        console.log("getStoreHome")
        this.getStoreHome()
      } else {
        // this.get
        console.log("getStoreMessage")
        this.getStoreMessage()
      }
    } else {
      console.log("222")
      this.wifi = 2
      this.upCorer()

      let reception = this.$route.query
      this.getAllStorePermissionsList2()

      if (window.plus) {
        this.getLocationOnReady()
      } else {
        document.addEventListener('plusready', this.getLocationOnReady, false)
      }
      if (Object.entries(reception).length !== 0) {
        this.getstore()
      } else {
        // this.get
        this.getStoreMessage2()
      }
    }
  },
  methods: {
    ...mapActions(['setStoreId']),
    handleVideoEnd() {
      console.log('视频播放完成');
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        // 暂停视频播放
        videoPlayer.pause();
        // 如果需要，设置当前时间为 0
        videoPlayer.currentTime = 0;
      }
    },
    onMouseDown() {
      console.log('mouse down');
      this.isDragging = true;
    },
    onMouseUp() {
      console.log('mouse up');
      setTimeout(() => {
        this.isDragging = false;
      }, 100); // 延时 100ms
    },
    onTouchStart() {
      console.log('touch start', this.isDragging, this.btnIsClick);
      this.isDragging = true;
    },
    onTouchEnd() {
      console.log('touch end', this.isDragging, this.btnIsClick);
      setTimeout(() => {


        this.isDragging = false;
        console.log('----------reset ', this.isDragging);

      }, 100); // 延时 100ms
    },
    setLotteryPosition() {
      const linkDiv = document.querySelector('.link');
      const backIcon = document.querySelector('.backIcon'); // 获取 .backIcon 元素

      console.log('-----', linkDiv, backIcon);
      if (linkDiv && backIcon) {
        // 获取 link 元素的位置信息
        const linkRect = linkDiv.getBoundingClientRect();

        // 设置 backIcon 的位置，使其漂浮在 link 左侧
        //backIcon.style.position = 'absolute'; // 确保 backIcon 是绝对定位
        backIcon.style.top = `${linkRect.top}px - 90`;
        backIcon.style.left = `${linkRect.left - 70}px`; // 调整 -10px 可以自定义偏移量
      }
    },
    handleClick() {
      console.log('handle click test', this.isDragging, this.btnIsClick)
      if (this.btnIsClick) {
        this.gotoLottery();
      }
    },
    gotoLottery() {
      console.log('gotoLottery')
      this.$router.push('/Lottery?storeId=' + this.storeId);
    },
    //更新产品表封面
    async upCorer() {
      var that = this
      const res = await indexedDB.dbOperation('productsAll', 'getAll')
      res.forEach(async (v, i) => {
        const r = await indexedDB.dbOperation('productCover', 'get', v.id)

        if (r.imgFiles) {
          v.productCover = r.imgFiles
        }

        indexedDB.update('productsAll', v)
      })
    },

    // 获取全部店铺权限
    async getAllStorePermissionsList2() {
      const res = await indexedDB.dbOperation('allStorePermissionsList', 'getAll')
      this.permissionsList = res
    },

    //我的展台页面数据1
    async getStoreMessage2() {
      var that = this
      let personId = localStorage.getItem('id')
      console.log('personId', personId)
      if (personId) {
        if (!navigator.onLine) {
          const data = await indexedDB.dbOperation('storeArr', 'get', parseInt(personId))
          console.log('getStoreMessage2()', data)

          let obj = data
          if (obj == undefined) {
            return
          }
          if (Object.entries(obj).length !== 0) {
            that.storeArr = obj
            localStorage.setItem('storeId', that.storeArr.storeId)
          }
        } else {
          // let userId = parseInt(personId) //字符串转整数
          // that.getstore('store', userId, 'userId')
        }
      }
    },

    //读取store数据
    async getstore(st, dat, index) {
      console.log("aaaaaaaaa")
      var that = this
      const conn = window.indexedDB.open(this.mydbname, this.myversion)
      conn.onsuccess = function (event) {
        var db = event.target.result

        var request = db.transaction([st]).objectStore(st).index(index).get(dat)
        request.onsuccess = async function (event) {
          if (request.result) {
            var obj = request.result

            let setObj = {
              backgroundImgs: obj.background.split(','),
              logo: obj.logo,
              honestyName: obj.honestyName,
              showroomUrl: obj.showroomUrl,
              introduce: obj.storeDetails,
              storeId: obj.id,
              storeIdentity: obj.storeIdentity,
              storeName: obj.name
            }
            that.storeArr = setObj
            console.log('--------obj', obj)
            if (obj.video.length > 0) {
              that.videoFiles = obj.video.split(',')
            } else {
              that.videoFiles = []
            }

            localStorage.setItem('storeId', that.storeArr.storeId)
            //  that.msg=that.storeArr;
          }
        }
      }
    },

    // async add () {

    //     const data = {
    //         name: 'name',
    //         age: 'age',
    //         email: 'email@11.11'
    //     }
    //     const res = await indexedDB.dbOperation('add');
    //     console.log(res);
    //     },

    //     async read () {
    //     const res = await indexedDB.dbOperation('get', 1)
    //     console.log(res)
    //     },

    // 查询用户是否购买功能权限
    async getUserWhetherPurchaseStorePermissions(id) {
      // return new Promise(reslove => {
      let parma = {
        storeId: localStorage.getItem('storeId'),
        powersId: id
      }
      //  console.log(parma);
      // let res = aGet(api.getUserWhetherPurchaseStorePermissions,parma)
      await aGet(api.getUserWhetherPurchaseStorePermissions, parma).then((res) => {
        this.powerStatus = res.data
        //  console.log("222", this.powerStatus);
      })

      // console.log('查询用户是否购买功能权限',res);

      // reslove(res.data)
      // })
    },
    // 获取全部店铺权限
    getAllStorePermissionsList() {
      aGet(api.getAllStorePermissionsList).then((res) => {
        // console.log("全部店铺权限", res);
        this.permissionsList = res.data.data
        // console.log("xxxx", this.permissionsList);
      })
    },

    // 展厅
    async jumpExhibition() {
      let obj = this.permissionsList.filter((item) => item.powerName == '展厅')
      let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id)

      // setTimeout( () => {
      if (this.powerStatus != undefined && this.powerStatus == false) {
        this.$toast('您暂无此权限,请先购买权限配置！')
        this.$router.push({
          path: '/buyservice'
        })
      } else if (this.powerStatus != undefined && this.powerStatus == true) {
        this.$router.push({
          path: '/Exhibition'
        })
      }
      // },300)
    },
    ...mapActions(['setBoothStoreDetail']),
    //上滑进入展品列表
    topSlide() {
      if (!this.isDragging) {
        let path = this.storeArr.storeIdentity === 2 ? '/AdvertisingBooth' : this.storeArr.storeIdentity === 1 ? '/userBooth' : ''

        this.$router.push({
          path: path,
          query: {storeId: this.storeArr.storeId}
        })
      }

    },
    //店铺首页数据
    async getStoreHome() {
      console.log("bbbb")
      let storeId = this.$route.query.id
      let {data} = await this.$http.aPost(this.$api.getHomePageStore, {
        storeId
      })
      console.log('home data:', data)
      this.storeArr = data.storeHomePage

      // console.log('店铺首页数据:',data);
    },
    //我的展台页面数据
    async getStoreMessage() {
      console.log("ccc")
      let personId = localStorage.getItem('id')
      if (personId) {
        let {data} = await this.$http.aPost(this.$api.getStoreMessage, {
          id: personId
        })
        let obj = data.data.store
        console.log(JSON.stringify(data.data.store))
        if (Object.entries(obj).length !== 0) {
          let setObj = {
            backgroundImgs: obj.background.split(','),
            logo: obj.logo,
            honestyName: obj.honestyName,
            showroomUrl: obj.showroomUrl,
            introduce: obj.storeDetails,
            storeId: obj.id,
            storeIdentity: obj.storeIdentity,
            storeName: obj.name
          }
          this.storeArr = setObj
          if (obj.video.length > 0) {
            this.videoFiles = obj.video.split(',')
          } else {
            this.videoFiles = []
          }
          localStorage.setItem('type', this.storeArr.storeIdentity)
        }
        localStorage.setItem('storeId', this.storeArr.storeId)

      }
    },

    // get(){
    //   var that=this;
    //   const conn = window.indexedDB.open(that.mydbname,that.myversion);

    //             conn.onsuccess = function (event) {
    //                 const db = event.target.result;
    //                 var transaction = db.transaction(['store'], 'readonly');
    //                 var store = transaction.objectStore('store');
    //                 var index = store.index('userId');
    //                 let userId = parseInt(personId);//字符串转整数
    //                 var request = index.get(userId);
    //                 request.onsuccess = function (e) {
    //                   const result = e.target.result;
    //                   return result;
    //                 }
    //             }
    //           },

    async imgUrlToBase64(imageUrl) {
      var img64
      var that = this

      var promise = new Promise((res) => {
        let image = new Image() // 一定要设置为let，不然图片不显示
        image.setAttribute('crossOrigin', 'anonymous') // 解决跨域问题
        //image.src = imageUrl +"&v=" + Math.random() // 如果是本地图片替换为 image.src = imageUrl
        image.src = imageUrl // 如果是本地图片替换为 image.src = imageUrl
        image.onload = () => {
          var canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          var context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          var quality = 0.8
          var dataURL = canvas.toDataURL('image/jpeg', quality) // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
          img64 = dataURL
          res(img64)
        }
      })

      await promise

      return img64
    },

    getLocationOnReady() {
      plus.geolocation.getCurrentPosition(
        (p) => {
          this.latitude = p.coords.latitude
          this.longitude = p.coords.longitude
          let location = {
            latitude: this.latitude,
            longitude: this.longitude
          }
          //  console.log(location)
          sessionStorage.setItem('location', JSON.stringify(location))
          sessionStorage.setItem('latitude', this.latitude)
          sessionStorage.setItem('longitude', this.longitude)
          console.log('location2', JSON.stringify(location))
          // alert('Geolocation\nLatitude:' + p.coords.latitude + '\nLongitude:' + p.coords.longitude + '\nAltitude:' + p.coords.altitude);
        },
        function (e) {
          console.log("定位错误2", e.message)
          alert('请打开定位')
        }
      )
    }
  },
  mounted() {
    this.setLotteryPosition();

    // 获取视频元素
    const videoPlayer = this.$refs.videoPlayer;

    // 监听视频播放结束事件
    if (videoPlayer) {
      videoPlayer.addEventListener('ended', this.handleVideoEnd);
    }
  },
  beforeDestroy() {
    // 在组件销毁时移除事件监听
    const videoPlayer = this.$refs.videoPlayer;
    if (videoPlayer) {
      videoPlayer.removeEventListener('ended', this.handleVideoEnd);
    }
  },
  //自定义上滑指令
  directives: {
    //滑动指令
    touch: {
      bind: function (el, binding) {
        var touchType = binding.arg //传入的模式 press swipeRight swipeLeft swipeTop swipeDowm Tap
        var timeOutEvent = 0
        var direction = ''
        //滑动处理
        var startX, startY

        //返回角度
        function GetSlideAngle(dx, dy) {
          return (Math.atan2(dy, dx) * 180) / Math.PI
        }

        //根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
        function GetSlideDirection(startX, startY, endX, endY) {
          var dy = startY - endY
          var dx = endX - startX
          var result = 0

          //如果滑动距离太短
          if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
            return result
          }

          var angle = GetSlideAngle(dx, dy)
          if (angle >= -45 && angle < 45) {
            result = 'swiperight'
          } else if (angle >= 45 && angle < 135) {
            result = 'swipeup'
          } else if (angle >= -135 && angle < -45) {
            result = 'swipedown'
          } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
            result = 'swipeleft'
          }
          return result
        }

        el.addEventListener(
          'touchstart',
          function (ev) {
            startX = ev.touches[0].pageX
            startY = ev.touches[0].pageY

            //判断长按
            timeOutEvent = setTimeout(() => {
              timeOutEvent = 0
              if (touchType === 'press') {
                binding.value()
              }
            }, 500)
          },
          false
        )

        el.addEventListener('touchmove', function () {
          clearTimeout(timeOutEvent)
          timeOutEvent = 0
        })

        el.addEventListener(
          'touchend',
          function (ev) {
            var endX, endY
            endX = ev.changedTouches[0].pageX
            endY = ev.changedTouches[0].pageY
            direction = GetSlideDirection(startX, startY, endX, endY)

            clearTimeout(timeOutEvent)

            switch (direction) {
              case 0:
                break
              case 'swipeup':
                if (touchType === 'swipeup') {
                  binding.value()
                }
                break
              case 'swipedown':
                if (touchType === 'swipedown') {
                  binding.value()
                }
                break
              case 'swipeleft':
                if (touchType === 'swipeleft') {
                  binding.value()
                }
                break
              case 'swiperight':
                if (touchType === 'swiperight') {
                  binding.value()
                }
                break
              default:
            }
          },
          false
        )
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../assets/mixin';

// 通用变量
$primary-color: #50cc73;
$secondary-color: #2fb555;
$text-color: #333;
$light-text-color: #666;
$border-radius: 20px;

// 全局响应式
@media (max-height: 700px) {
  .img-height {
    height: 75vh;
  }
}

@media (min-height: 701px) {
  .img-height {
    height: 78vh;
  }
}

// 容器布局
.booth {
  width: 100%;
  height: 95%;

  .swiper-wrapper {
    width: 100%;
    height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .booth-bannerImg {
      width: 100%;
      max-height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .content {
    width: 100%;
    height: 240px;
    position: fixed;
    bottom: 100px;
    left: 0;
    background-color: #fff;
    border-top-left-radius: $border-radius;
    border-top-right-radius: $border-radius;
    padding: 26px 20px 0;

    .info {
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 26px;

        .left {
          .booth-title {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left {
              display: flex;
              justify-content: flex-start;
              align-items: center;

              img {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                object-fit: cover;
              }

              span {
                display: inline-block;
                line-height: 56px;
                margin-left: 16px;
                font-size: 32px;
                color: #000000;
                text-stroke: 1 rgba(0, 0, 0, 0);
                font-weight: bold;
              }
            }

            ul {
              display: flex;
              align-items: center;
              margin-left: 20px;
              font-size: 28px;

              li {
                &:first-child {
                  text-stroke: 1 rgba(0, 0, 0, 0);
                  color: #666666;
                }

                &:last-child {
                  margin-left: 16px;
                  font-weight: bold;
                  color: #333333;
                }
              }
            }
          }
        }

        .link {
          width: auto;
          height: 96px;
          padding: 0 17px;
          display: flex;
          align-items: center;
          position: relative;

          div {
            width: 128px;
            height: 48px;
            border: 1px solid rgba(0, 0, 0, 0);
            background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
            border-radius: 40px;
            outline: none;
            text-align: center;
            line-height: 48px;
            font-size: 24px;
            color: #ffffff;
          }

          span {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 26px;
            color: #666666;

            &:before {
              content: '';
              width: 26px;
              height: 26px;
              display: inline-block;
              background: url('../../assets/img/home/go-up.png') center bottom no-repeat;
              background-size: contain;
              margin-right: 16px;
              margin-bottom: -5px;
            }
          }
        }

      }
    }

    .link-slide {
      text-align: center;
      margin-top: 10px;

      span {
        font-size: 14px;
        color: $light-text-color;

        &:before {
          content: '';
          width: 26px;
          height: 26px;
          display: inline-block;
          background: url('../../assets/img/home/go-up.png') center bottom no-repeat;
          background-size: contain;
          margin-right: 8px;
        }
      }
    }
  }
}

// 视频和图片适配
.custom-swipe {
  width: 100%;
  height: 100%;

  .media-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    img,
    video {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
}

// Swipe 组件指示器
/deep/ .van-swipe {
  height: 100%;

  & > > > .van-swipe__indicators {
    bottom: 10px;

    i {
      width: 10px;
      height: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue